<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { DiscreteScaleLevel } from '@Scales/Model';
    import { CriterionScaleEditorViewModel } from "@Criteria/Hierarchies/Components/CriterionScaleEditor";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class CriterionScaleEditor extends Vue
    {
        get vm(): CriterionScaleEditorViewModel { return this.$props.viewModel as CriterionScaleEditorViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get criterionId(): number { return this.vm.criterionId; }
        get criterionName(): string { return this.vm.criterionName; }
        get criterionDescription(): string | null { return this.vm.criterionDescription; }
        get levels(): DiscreteScaleLevel[] { return this.vm.levels; }
        get error(): string | null { return this.vm.error; }

        addLevel()
        {
            this.clearValidationErrors();
            this.levels.push({ Name: null, Value: null, Definition: null });
        }

        deleteLevel(l: DiscreteScaleLevel)
        {
            this.clearValidationErrors();
            this.levels.remove(l);
        }

        clearValidationErrors()
        {
            this.vm.error = null;
        }

        emitAssignCustomScale()
        {
            this.clearValidationErrors();
            this.$emit("assign-custom-scale", this.criterionId, this.levels);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Criterion: {{criterionName}}</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="criterion-scale-editor-form" @submit.prevent="emitAssignCustomScale">
                            <p class="lead">{{criterionDescription}}</p>

                            <div class="row" style="margin-bottom: 5px;">
                                <div class="col-sm-3">
                                    <label>Scale level <span class="text-danger">*</span></label>
                                </div>
                                <div class="col-sm-2">
                                    <label>Value <span class="text-danger">*</span></label>
                                </div>
                                <div class="col-sm-6">
                                    <label>Definition</label>
                                </div>
                            </div>

                            <div>
                                <div v-for="sl in levels" class="row" style="margin-bottom: 5px;">
                                    <div class="col-sm-3">
                                        <input v-model.trim="sl.Name" type="text" required maxlength="100" class="form-control" placeholder="Level">
                                    </div>
                                    <div class="col-sm-2">
                                        <input type="number" v-model.number="sl.Value" placeholder="Number..." class="form-control" required min="0" step="any">
                                    </div>
                                    <div class="col-sm-6">
                                        <input v-model.trim="sl.Definition" type="text" class="form-control" placeholder="Definition for level">
                                    </div>
                                    <div class="col-sm-1">
                                        <a @click="deleteLevel(sl)" class="pointer fa fa-times"></a>
                                    </div>
                                </div>
                            </div>
                            <div class="error">{{error}}</div>

                            <p><a class="text-primary" @click="addLevel">Add scale level</a></p>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="criterion-scale-editor-form" class="btn btn-primary">Update</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped>
</style>